import axiosInstance from '@/services/axiosInstance'

async function getLicenciaUso () {
  const req = {
    url: 'api/config/getlastlicenciauso',
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
  }
  const res = await axiosInstance(req)
  return res.data
}

export { getLicenciaUso }
